import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function extractIdsFromArray(arr: any, values: any) {
  return arr
    ?.filter((item: any) => values?.includes(item?.name))
    .map((item: any) => item?._id);
}

// extract name form category array
export function extractNamesFromArray(data: any) {
  return data?.map((item: any) => item?.name);
}
// extract name, size, price, stock from variant array
export function extractVariantInfo(variants: any) {
  return variants?.map((variant: any) => ({
    name: variant.name,
    size: variant.size,
    price: variant.price,
    stock: variant.stock,
  }));
}

export function extractFileInfo(imageFiles: any) {
  return imageFiles?.map((file: any) => ({
    path: file.path,
    lastModified: file.lastModified,
    lastModifiedTime: file.lastModified,
    name: file.name,
    size: file.size,
    type: file.type,
  }));
}

export const extractVideoId = (url: string) => {
  const regExp =
    /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|watch\?.+&v=)([^&\n]{11})/;
  const match = url?.match(regExp);
  return match ? match[2] : null;
};
